import React from 'react';

const TeamValueGrid = () => {
  const valueCards = [
    {
      title: 'Deal Discipline',
      body: 'Sourcing and underwriting single-tenant NN/NNN assets where tenant quality, lease terms, and location drive durable cash flow'
    },
    {
      title: 'Edge in Negotiation',
      body: 'Repeat counterparties, data-driven diligence, and structured terms that protect income and upside'
    },
    {
      title: 'Operational Rigor',
      body: 'Hands-on asset management, measured leverage, and portfolio-level scale to support institutional exits'
    },
    {
      title: 'Aligned & Transparent',
      body: 'Clear reporting, on-chain records for ownership and distributions, and investor-first communication'
    },
    {
      title: 'Compliance-First',
      body: 'KYC/AML, wallet whitelisting, and approved secondary venues. We build for regulatory durability'
    }
  ];

  return (
    <section className="team-value-grid">
      <div className="team-value-grid-container">
        <div className="team-value-grid-cards">
          {valueCards.map((card, index) => (
            <div
              key={index}
              className="team-value-card"
            >
              <h3 className="team-value-card-title">
                {card.title}
              </h3>
              <p className="team-value-card-body">
                {card.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamValueGrid;
